import { useQuery } from "@tanstack/react-query";
import SysUiRule from "app/class/sys-ui-rule";
import { RecordManagement } from "app/class/record-management";
import queryKeys from "shared/services/queryKeys";

export function useUiRules(tableId?: string, enabled = true) {
    return useQuery({
        queryKey: queryKeys.records.config("sys_ui_rules", { sys_table_id: tableId, active: true }),
        enabled: enabled && Boolean(tableId),
        retry: (failureCount, error) => (error as any)?.response?.status !== 403 && failureCount < 3,
        select: (response: any) =>
            response.data
                .map((item: any) => new SysUiRule(item))
                .sort((left: SysUiRule, right: SysUiRule) => {
                    if (right.priority !== left.priority) {
                        return right.priority - left.priority;
                    }

                    return left.created_at.getTime() - right.created_at.getTime();
                }),
        queryFn: () =>
            new RecordManagement<SysUiRule>("sys_ui_rules")
                .where("active", true)
                .where("sys_table_id", tableId)
                .orderBy("priority", "desc")
                .run(),
        staleTime: 1000 * 60,
    });
}
